import { gql } from '@apollo/client'
import { Button, LikeActiveIcon, LikeIcon, useToast } from '@farol-ds/react'
import { GA4EventProps, useMetrics } from '@jusbrasil-web/docview/core'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import {
  FEEDBACK_CLASS,
  FEEDBACK_METHOD,
  GA4FeedbackGivenEvent,
} from '@jusbrasil-web/shared-ga4-events'

import { useLikeDocument } from '../../hooks'
import { LikeDocumentButton_DocumentFragment } from './__generated__/like-document-button.graphql'

export interface LikeDocumentButtonProps {
  document: LikeDocumentButton_DocumentFragment
  ga4EventData: GA4EventProps
}

export function LikeDocumentButton(props: LikeDocumentButtonProps) {
  const { document, ga4EventData } = props
  const { viewerLiked, docId } = document
  const vote = viewerLiked ? 'NONE' : 'POSITIVO'
  const UpVoteButtonIcon = viewerLiked ? LikeActiveIcon : LikeIcon

  const toast = useToast()
  const { likeDocument, loading: loadingLikeDocument } = useLikeDocument({
    document,
    vote,
  })
  const { ref: dispatcherRef, sendMetrics } = useMetrics<HTMLButtonElement>()
  const { sendGA4Event } = useGA4Dispatcher()

  const handleClick = async () => {
    await likeDocument()
    if (!viewerLiked) {
      toast('Documento curtido', { id: 'like-document' })
      sendMetrics('Doc.VotedUp')
      sendGA4Event(
        new GA4FeedbackGivenEvent({
          ...ga4EventData,
          componentName: null,
          feedbackClass: FEEDBACK_CLASS.CONTENT_FEEDBACK,
          feedbackMethod: FEEDBACK_METHOD.LIKE,
        })
      )
    } else {
      sendMetrics('Doc.UnVotedUp')
    }
  }

  return (
    <Button
      leftIcon={<UpVoteButtonIcon />}
      loading={loadingLikeDocument}
      onClick={handleClick}
      data-testid={`like-document-button-${docId}-${viewerLiked ? 'DISLIKE' : 'LIKE'}${
        loadingLikeDocument ? ` like-document-button-${docId}-loading` : ''
      }`}
      ref={dispatcherRef}
    >
      Curtir
    </Button>
  )
}

LikeDocumentButton.fragments = {
  document: gql`
    fragment LikeDocumentButton_document on Document {
      viewerLiked
      ...UseLikeDocument_document
    }
    ${useLikeDocument.fragments.document}
  `,
}
